import { View, StyleSheet, ViewStyle } from 'react-native';
import Animated, { 
  useAnimatedStyle, 
  withRepeat, 
  withSequence, 
  withTiming,
  useSharedValue,
} from 'react-native-reanimated';
import { useColors, ThemeColors } from '../../hooks/useColors';

interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  borderRadius?: number;
  style?: ViewStyle;
}

export function Skeleton({ 
  width = '100%', 
  height = 20, 
  borderRadius = 4,
  style 
}: SkeletonProps) {
  const colors = useColors();
  const styles = createStyles(colors);
  const opacity = useSharedValue(0.3);

  const animatedStyle = useAnimatedStyle(() => ({
    opacity: opacity.value,
  }));

  // Start the animation
  opacity.value = withRepeat(
    withSequence(
      withTiming(0.7, { duration: 1000 }),
      withTiming(0.3, { duration: 1000 })
    ),
    -1,
    true
  );

  return (
    <Animated.View style={[
      styles.skeleton,
      { width, height, borderRadius },
      animatedStyle,
      style,
    ]} />
  );
}

const createStyles = (colors: ThemeColors) => StyleSheet.create({
  skeleton: {
    backgroundColor: colors.border,
  },
}); 